import api from '../baseAPIs/core';
import { AuditLogWithUser } from '@extTypes/auditLog/types';

export const getAuditEntriesWithUsers = async (entityType: string, entityId: string): Promise<AuditLogWithUser[]> => {
    const response = await api.get<AuditLogWithUser[]>('AuditLog', { params: { entityType, entityId } });
    return response.data;
};
